export default __webpack_public_path__ + "800f0c2a0d60323f004859dcb5139f6c.svg";